import axios from 'axios';
import { secureStorage } from "./utils/secureStorage";
import APP_CONFIG from "./config";

// 🔹 Instance **publique** — sans token
const axiosPublic = axios.create({
    baseURL: APP_CONFIG.REACT_APP_DASHBOARD_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

// 🔒 Instance **authentifiée** — avec token + CSRF
const axiosAuth = axios.create({
    baseURL: APP_CONFIG.REACT_APP_DASHBOARD_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

// Intercepteur pour l'instance authentifiée
axiosAuth.interceptors.request.use(
    async (config) => {
        // Ajout du CSRF token
        const csrfToken = document.cookie
            .split('; ')
            .find(row => row.startsWith('XSRF-TOKEN='))
            ?.split('=')[1];

        if (csrfToken) {
            config.headers['X-XSRF-TOKEN'] = decodeURIComponent(csrfToken);
        }

        // Ajout du Bearer token
        const accessToken = secureStorage.get('access_token');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Intercepteur commun d'erreurs (facultatif)
const handleErrors = (error) => {
    if (error.response) {
        console.error('Erreur API :', error.response.data.message || error.response.statusText);
    } else if (error.request) {
        console.error("Erreur lors de l'envoi de la requête");
    } else {
        console.error("Erreur inconnue :", error.message);
    }
    return Promise.reject(error);
};

axiosPublic.interceptors.response.use((res) => res, handleErrors);
axiosAuth.interceptors.response.use((res) => res, handleErrors);
const axiosLogout = axios.create({
    baseURL: APP_CONFIG.REACT_APP_DASHBOARD_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

const  logoutRequest = async (token) => {
    if (!token) return;

    return axiosLogout.post(
        '/api/logout',
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};
// ✅ Exportation des deux instances
export { axiosPublic, axiosAuth , logoutRequest };
